import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { MOBILE_CLIENT } from "@/lib/mobileRouting";

// ── PWA setup pour les builds mobiles ──
if (MOBILE_CLIENT) {
  // Titre + thème
  document.title = "Mon Espace — TPCO Sénégal";
  // Manifest dédié
  const link = document.createElement("link");
  link.rel = "manifest";
  link.href = "/manifest.client.json";
  document.head.appendChild(link);
  // Service Worker (cache statique)
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw-client.js").catch(() => {});
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
